/**
 * @generated SignedSource<<58b79f1419deafa6ddfa1630f4ce827a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useVaccinationStatusCriteria_query$data = {
  readonly currentUser: {
    readonly vaccinationStatusCriteria: {
      readonly nodes: ReadonlyArray<{
        readonly vaccinationStatusId: any;
      } | null | undefined>;
    };
  } | null | undefined;
  readonly " $fragmentType": "useVaccinationStatusCriteria_query";
};
export type useVaccinationStatusCriteria_query$key = {
  readonly " $data"?: useVaccinationStatusCriteria_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"useVaccinationStatusCriteria_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useVaccinationStatusCriteria_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "currentUser",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "orderBy",
              "value": [
                "VACCINATION_STATUS_BY_VACCINATION_STATUS_ID__SEQUENCE_ASC"
              ]
            }
          ],
          "concreteType": "VaccinationStatusCriterionConnection",
          "kind": "LinkedField",
          "name": "vaccinationStatusCriteria",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "VaccinationStatusCriterion",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "vaccinationStatusId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "vaccinationStatusCriteria(orderBy:[\"VACCINATION_STATUS_BY_VACCINATION_STATUS_ID__SEQUENCE_ASC\"])"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "b3360247964e78e424e438962ea02aed";

export default node;
